import { SparklesIcon } from 'assets/icons';
import Button from 'components/button';
import StyledInput from 'components/styledInput/StyledInput';
import { EMAIL_TEMPLATES } from 'constants/emailTemplates';
import useText from 'hooks/useText';
import { useState } from 'react';

// The e-mail an e-mail task will send, drafted from its description: its
// template, subject and message, edited in place by whoever may edit the task.
const TaskEmailCard = ({ task, onSave, canEdit = true }) => {
  const { text } = useText('taskPanel');
  const [draft, setDraft] = useState(null);
  const change = (field) => (event) => setDraft((current) => ({ ...current, [field]: event.target.value }));

  if (draft) {
    return (
      <div className="flex flex-col gap-4 rounded-lg border border-gray-200 p-4">
        <p className="text-sm font-medium text-gray-900">{text('emailEdit')}</p>
        <StyledInput
          type="select"
          label={text('emailTemplateLabel')}
          value={draft.emailTemplate}
          list={EMAIL_TEMPLATES.map((template) => ({ value: template, label: template }))}
          onChange={change('emailTemplate')}
        />
        <StyledInput type="text" label={text('emailSubjectLabel')} value={draft.emailSubject} onChange={change('emailSubject')} />
        <StyledInput
          type="textarea"
          label={text('emailBodyLabel')}
          value={draft.emailBody}
          maxLength={5000}
          onChange={change('emailBody')}
        />
        <div className="flex justify-end gap-3">
          <Button color="SECONDARY" size="SM" onClick={() => setDraft(null)}>
            {text('cancel')}
          </Button>
          <Button
            color="PRIMARY"
            size="SM"
            onClick={async () => {
              if (await onSave(draft)) setDraft(null);
            }}
          >
            {text('save')}
          </Button>
        </div>
      </div>
    );
  }
  return (
    <div className="flex flex-col gap-2 rounded-lg border border-gray-200 p-4">
      <div className="flex items-center justify-between">
        <p className="flex items-center gap-2 text-sm font-medium text-gray-900">
          <SparklesIcon wh={16} color="currentColor" />
          {text('emailReady')}
        </p>
        {canEdit && (
          <Button
            color="SECONDARY"
            size="SM"
            onClick={() =>
              setDraft({
                emailTemplate: task.emailTemplate || EMAIL_TEMPLATES[0],
                emailSubject: task.emailSubject,
                emailBody: task.emailBody,
              })
            }
          >
            {text('emailEditButton')}
          </Button>
        )}
      </div>
      <p className="text-xs text-gray-600">{text('emailTemplate', { template: task.emailTemplate || text('emailNoTemplate') })}</p>
      <p className="text-sm font-medium text-gray-900">{text('emailSubject', { subject: task.emailSubject || '-' })}</p>
      <p className="whitespace-pre-line text-sm text-gray-600">{task.emailBody || text('emailEmpty')}</p>
    </div>
  );
};

export default TaskEmailCard;
